class ZeusResponsive {
	// If you change these values, make sure to update the values in block-visibility.scss
	static MOBILE_MAX = 767;
	static TABLET_MIN = 768;
	static TABLET_MAX = 1024;

	constructor() {
		this.removedElements = new Map();
		this.mediaQueries = {
			mobile: window.matchMedia( `(max-width: ${ ZeusResponsive.MOBILE_MAX }px)` ),
			tablet: window.matchMedia( `(min-width: ${ ZeusResponsive.TABLET_MIN }px) and (max-width: ${ ZeusResponsive.TABLET_MAX }px)` ),
			desktop: window.matchMedia( `(min-width: ${ ZeusResponsive.TABLET_MAX + 1 }px)` ),
		};
		this.init();
	}

	/**
	 * Initialize the event listeners for resizing the window
	 *
	 * @return {void}
	 */
	init() {
		Object.values( this.mediaQueries ).forEach( ( mql ) => {
			mql.addEventListener( 'change', this.checkElementsVisibility.bind( this ) );
		} );

		this.checkElementsVisibility();
	}

	/**
	 * Get the device type based on the window width
	 *
	 * @return {string} The device type ('mobile', 'tablet', or 'desktop')
	 */
	getDeviceType() {
		if ( this.mediaQueries.mobile.matches ) {
			return 'mobile';
		} else if ( this.mediaQueries.tablet.matches ) {
			return 'tablet';
		} else if ( this.mediaQueries.desktop.matches ) {
			return 'desktop';
		}

		return 'unknown';
	}

	/**
	 * Check the visibility of elements based on the device type
	 * and add or remove them accordingly
	 *
	 * @return {void}
	 */
	checkElementsVisibility() {
		const elements = document.querySelectorAll( '.zeus-hide-js' );
		const deviceType = this.getDeviceType();

		elements.forEach( ( el, index ) => {
			const uniqueKey = index;
			const parent = el.parentNode;
			const placeholder = this.removedElements.get( uniqueKey )?.placeholder || document.createComment( '[zeus]' );

			if ( deviceType === 'mobile' && el.classList.contains( 'zeus-hide-mobile' ) ) {
				this.removeElement( el, parent, uniqueKey, placeholder );
			} else if ( deviceType === 'tablet' && el.classList.contains( 'zeus-hide-tablet' ) ) {
				this.removeElement( el, parent, uniqueKey, placeholder );
			} else if ( deviceType === 'desktop' && el.classList.contains( 'zeus-hide-desktop' ) ) {
				this.removeElement( el, parent, uniqueKey, placeholder );
			} else {
				this.addElement( uniqueKey );
			}
		} );

		this.maybeAddElement( deviceType );
	}

	/**
	 * Restore elements that are supposed to be visible based
	 * on the device type and current screen width
	 *
	 * @param {string} deviceType
	 */
	maybeAddElement( deviceType ) {
		this.removedElements.forEach( ( stored, key ) => {
			const shouldBeVisible =
				( deviceType === 'mobile' && ! stored.element.classList.contains( 'zeus-hide-mobile' ) ) ||
				( deviceType === 'tablet' && ! stored.element.classList.contains( 'zeus-hide-tablet' ) ) ||
				( deviceType === 'desktop' && ! stored.element.classList.contains( 'zeus-hide-desktop' ) );

			if ( shouldBeVisible ) {
				this.addElement( key ); // Re-add the element if it needs to be visible again
			}
		} );
	}

	/**
	 * Add the element back to the DOM
	 *
	 * @param {number} uniqueKey
	 */
	addElement( uniqueKey ) {
		const deviceType = this.getDeviceType();
		const stored = this.removedElements.get( uniqueKey );

		if ( stored && stored.placeholder && stored.parent.contains( stored.placeholder ) ) {
			// Avoid adding back elements that are still supposed to be hidden
			if ( deviceType === 'mobile' && stored.element.classList.contains( 'zeus-hide-mobile' ) ) {
				return;
			}

			if ( deviceType === 'tablet' && stored.element.classList.contains( 'zeus-hide-tablet' ) ) {
				return;
			}

			if ( deviceType === 'desktop' && stored.element.classList.contains( 'zeus-hide-desktop' ) ) {
				return;
			}

			stored.parent.replaceChild( stored.element, stored.placeholder );
			this.removedElements.delete( uniqueKey );
		}
	}

	/**
	 * Remove the element from the DOM and store it in a Map
	 *
	 * @param {HTMLElement} el
	 * @param {HTMLElement} parent
	 * @param {number}      uniqueKey
	 * @param {Comment}     placeholder
	 */
	removeElement( el, parent, uniqueKey, placeholder ) {
		if ( ! this.removedElements.has( uniqueKey ) ) {
			parent.insertBefore( placeholder, el );
			this.removedElements.set( uniqueKey, { element: el, placeholder, parent } );
			el.remove();
		}
	}
}

new ZeusResponsive();
